export function phoneNumber (p: string): string {
  if (!p) return ''
  // p = p.toString()
  return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4)
}
